import { theme as sharedTheme } from '@westwing/ui-kit/Theme';

export const signupOverlayTheme = {
    ...sharedTheme,
    loginRegisterForm: {
        wrapper: {
            margin: '20px auto 0',
        },
        submitButton: {
            fontFamily: sharedTheme.fonts.fontBrandonRegular,
            margin: '10px 0 20px',
            desktopFontSize: '14px',
        },
        input: {
            fontSize: '14px',
        },
    },
};

export const signupOverlayChecklistTheme = {
    ...sharedTheme,
    checklist: {
        item: {
            fontSize: '16px',
            padding: '0 0 0 34px',
            checkMarkWidth: '19px',
            checkMarkHeight: '14px',
        },
    },
};
